const { LOCALE_EN_GB } = require("./locale.constants")

const mondelezAPIs = [
    {
        siteID: "afh_mondelez",
        locale: "uken",
        pageLanguage: LOCALE_EN_GB,
        website_ids: [163],
    },
]
const countries = {
    uken: "uken",
}

const productsToHide = []
const recipesToHide = []

const tastehubProductConstants = {
    text: {
        name: "prd_name",
        dietary: "mdlz_foodservice_dietary",
        moodText: "mdlz_foodservice_mood_text",
        ingredients: "mdlz_foodservice_ingredients",
        productName: "mdlz_foodservice_product_name ", // Trailing space is intentional
        cuc: "mdlz_foodservice_cuc",
        tuc: "mdlz_foodservice_tuc",
        sku: "mdlz_foodservice_sku",
        usageConditions: "mdlz_foodservice_usage_conditions",
        allergens: "mdlz_foodservice_allergens",
    },
    image: {
        main: "afh_mondelez_600x600",
    },
}

const tastehubBrandConstants = {
    26742: { name: "belVita", portfolioId: 26742 },
    26739: { name: "Cadbury", portfolioId: 26739 },
    26743: { name: "Dairylea", portfolioId: 26743 },
    26741: { name: "Maynards", portfolioId: 26741 },
    26740: { name: "OREO", portfolioId: 26740 },
    26745: { name: "Philadelphia", portfolioId: 26745 },
    26744: { name: "Trebor", portfolioId: 26744 },
}

const tastehubRecipeConstants = {
    totalTime: "Total time",
    image: {
        main: 2230,
        detailPage: 2231,
    },
    brand: {
        22377: { name: "Cadbury" },
        22378: { name: "Oreo" },
        22379: { name: "Philadelphia" },
    },
}

const tastehubNutritionLabels = {
    energy: "kJ/Kcal",
    fat: "Fat",
    "saturated acids": "Saturated fat",
    carbohydrates: "Carbohydrate",
    sugar: "Sugars",
    fibres: "Fibre",
    protein: "Protein",
    sodium: "Sodium",
}

module.exports = {
    mondelezAPIs,
    countries,
    productsToHide,
    recipesToHide,
    tastehubProductConstants,
    tastehubBrandConstants,
    tastehubRecipeConstants,
    tastehubNutritionLabels,
}
